import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from '@app/shared/services';
import { InitTeacherService } from '@app/teacher/services';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '@environments/environment';
import { Teacher } from '@app/admin/model';
import { ContentAuditService } from '@app/audit/services';
import { ContentAuditPost } from '@app/audit/model';

// Declara a lib do videojs como externa ao angular
declare let videojs: any;

@Component({
  selector: 'content-view',
  templateUrl: './content-view.component.html',
  styleUrls: ['./content-view.component.css']
})
export class ContentViewComponent implements OnInit {
  private teacher: Teacher;
  
  private contentFile: string = `${environment.contentFiles}`;
  private structureFile: string;

  // Titulo do component
  title = 'Player com Video.JS';
  // Instancia do video.js.
  vidObj: any;
  // Poster para ser usado no video.js
  poster: string;
  // URL do video a ser reproduzido.
  video: string;
  //doc_pdf: string;
  videoType: string;
  // Subtitles
  subtitleEn: string;
  subtitlePt: string;
  serieName: string;
  episodeName: string;
  progressValue: number = 0;

  public episodeFlag: boolean = true;
  public subjectFlag: boolean = true;
  public OtherFlag: boolean = true;

  pdfSrc: string;
  public pdfSrcAsync$ = new BehaviorSubject("");

  // Acessa o elemento video do html5 via viewchild.
  @ViewChild('pdfViewer') pdfViewer: ElementRef;

  public type: string;
  public itemSerie: string;
  public itemEpisode: string;
  public itemIndex: number;
  returnUrl: string;
  public serieContent: any;
  public contentPath: string;
  public imgFileName: string;

  constructor(
    private http: HttpClient,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private loading: MessageService,
    private initTeacher: InitTeacherService,
    private contentAuditService: ContentAuditService
  ) {
    this.loading.showLoading();
    this.initTeacher.setConfigPage(false, false);
    this.teacher = this.initTeacher.teacher;
    this.returnUrl = '/teacher/course';
    this.structureFile = `${this.contentFile}/structure-files.json`;
  }

  ngOnInit() {
    this.loading.hideLoading();
    this.activatedRoute.params.subscribe(params => {
      this.type = params['type'];
      this.itemSerie = params['serie'];
      this.itemEpisode = params['episode'];
      this.itemIndex = params['index'];
      if (this.itemSerie && this.itemEpisode) {
        const obj = history.state.data;
        if (obj) {
          this.video = obj.video.replace('assets/content/pecm', 'https://d2km7a55p0pgkb.cloudfront.net').toString();
          this.videoType = obj.videoType.replace('assets/content/pecm', 'https://d2km7a55p0pgkb.cloudfront.net').toString();
          this.subtitleEn = obj.subtitleEn.replace('assets/content/pecm', 'https://d2km7a55p0pgkb.cloudfront.net').toString();
          this.subtitlePt = obj.subtitlePt.replace('assets/content/pecm', 'https://d2km7a55p0pgkb.cloudfront.net').toString();
          this.pdfSrc = obj.docPdf.replace('assets/content/pecm', 'https://d2km7a55p0pgkb.cloudfront.net').toString();
          this.pdfSrcAsync$.next(this.pdfSrc);
          this.serieName = obj.serieName;
          this.episodeName = obj.episodeName;

          this.OtherFlag = false;
          this.episodeFlag = true;
          this.subjectFlag = this.type != 'treinamento';

          var auditPost = new ContentAuditPost();
          auditPost.userId = this.teacher.userId;
          auditPost.episodeShortName = this.episodeName;
          this.contentAuditService.audit(auditPost);
        } 
        else {
          this.router.navigate([this.returnUrl]);
        }
      } else {
        this.router.navigate([this.returnUrl]);
      }
    });
  }

  ngAfterViewInit() {
    const options = {
      controls: true,
      autoplay: false,
      preload: 'auto',
      responsive: true,
      techOrder: ['html5']
    };
  }

  public callBackList() {
    this.router.navigate(['/teacher/contentlist', { serie: this.itemSerie, type: this.type }]);
  }

  private getJSON(): Observable<any> {
    var call = this.http.get<any>(this.structureFile);
    return call.pipe(map(response => {
      return response
    }));
  }

  getPDF(url: string) {
    const fileurl = `${url}/pdf`;
    const httpOptions = {
      headers: new HttpHeaders(
        {
          'Accept': 'application/json',
          'responseType':'blob'
        }
      )
    };
    return this.http.get<any>(fileurl, httpOptions);
  }

  pdfViewerSelect() {
    this.loading.showLoading();
    setTimeout(() => {
      this.pdfViewer.nativeElement.click();
      this.loading.hideLoading();
    }, 1000);
  }
}